import { render, staticRenderFns } from "./courseDemo.vue?vue&type=template&id=20984cff&scoped=true"
import script from "./courseDemo.vue?vue&type=script&lang=ts"
export * from "./courseDemo.vue?vue&type=script&lang=ts"
import style0 from "./courseDemo.vue?vue&type=style&index=0&id=20984cff&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20984cff",
  null
  
)

export default component.exports